/* eslint-disable */
import HttpService from '../HttpService';

export default class AdmissionMapService {
  constructor() {
    this._httpService = new HttpService('/sdi-bff/admission-map');
    this._httpSdiService = new HttpService('/sdi/admission-map');
  }

  // sdi
  async fetchAdmissions(params) {
    return this._httpSdiService.get('', params);
  }

  async export(payload) {
    return this._httpSdiService.post(`/export`, payload);
  }

  // sdi-bff
  async fetchAdmissionHistory(admissionId) {
    return this._httpService.get(`/${admissionId}/history`, {});
  }

  async fetchAdmissionGroups(params) {
    return this._httpService.get(`/financial-groups?${params}`, {});
  }

  async fetchAdmissionCarriers(params) {
    return this._httpService.get(`/carriers?${params}`, {});
  }

  async fetchAdmissionContracts(params) {
    return this._httpService.get('/contracts', params);
  }

  async fetchPasswordStatuses() {
    return this._httpService.get('/password-statuses');
  }

  async fetchUrgencyTypes() {
    return this._httpService.get('/urgency-types');
  }

  async fetchHighCostTypes() {
    return this._httpService.get('/high-cost');
  }

  async updateAdmission(id, params) {
    return this._httpService.put(`/${id}`, params);
  }
}
